import { FormEvent, useState, useRef, useEffect } from 'react'
import { useRouter } from 'next/router'
import { FaSearch, FaTimes } from 'react-icons/fa'

import { useWindowDimensions } from '@hooks/use-window-dimensions'
import { removeAccents } from '@utils/remove-accents'

export const SearchTool = () => {
  const router = useRouter()

  const [expanded, setExpanded] = useState(false)

  const inputRef = useRef<HTMLInputElement>(null)

  const { width } = useWindowDimensions()
  const isMobile = width < 1024

  const onSubmit = (ev: FormEvent) => {
    ev.preventDefault()

    const search = inputRef.current.value

    if (search.trim() === '') return

    router.push({
      pathname: '/noticias/resultado-pesquisa',
      query: { q: removeAccents(search) }
    })
  }

  useEffect(() => {
    if (isMobile) setExpanded(true)
    else setExpanded(false)
  }, [isMobile])

  return (
    <div className="w-full flex items-center justify-between">
      <p className="hidden lg:block h-3 text-base leading-4 tracking-[1.2px] font-normal text-[#00000073]">
        NAVEGUE ENTRE AS SEÇÕES
      </p>

      <form
        onSubmit={onSubmit}
        className={`lg:max-w-xs h-10 flex items-center ${
          expanded
            ? 'w-full bg-gray-100'
            : 'w-10 bg-transparent hover:bg-gray-100'
        } rounded-full overflow-hidden transition-all duration-500`}
      >
        <button
          type="submit"
          aria-label="Abrir barra de pesquisa"
          onClick={() => !isMobile && setExpanded(true)}
          className="w-10 min-w-[40px] h-10 min-h-[40px] flex items-center justify-center rounded-full transition duration-300"
        >
          <FaSearch className="w-4 h-4 text-[#00000073]" />
        </button>

        <input
          ref={inputRef}
          name="search"
          placeholder="PESQUISAR"
          className={`w-full bg-transparent text-sm leading-4 tracking-[0.8px] text-gray-700 placeholder:text-sm placeholder:leading-4 placeholder:tracking-[0.8px]`}
        />

        {!isMobile && (
          <button
            type="submit"
            aria-label="Fechar barra de pesquisa"
            onClick={() => setExpanded(false)}
            className={`w-10 h-10 flex items-center justify-center rounded-full transition duration-300`}
          >
            <FaTimes className="w-4 h-4 text-[#00000073]" />
          </button>
        )}
      </form>
    </div>
  )
}
